import moment from 'moment'
import { useEffect, useRef, useState } from 'react'

const timestamp = (reservation, field) => {
  if (reservation[`${field}At`]) return new Date(reservation[`${field}At`]).getTime()
  return moment(`${reservation[`${field}Date`]} ${reservation[`${field}Time`]}`, 'YYYY-MM-DD HH:mm', true).valueOf()
}

export const getReservationStatus = (reservation, now = Date.now()) =>
  reservation.status === 'approved' && timestamp(reservation, 'return') <= now ? 'completed' : reservation.status

export const canCancelReservation = (reservation, now = Date.now()) =>
  ['pending', 'approved'].includes(getReservationStatus(reservation, now)) && timestamp(reservation, 'departure') > now

export const hasDeparted = (reservation, now = Date.now()) => !(timestamp(reservation, 'departure') > now)

const useReservationClock = (reservations, onBoundary) => {
  const [tick, setTick] = useState(0)
  const callback = useRef(onBoundary)
  callback.current = onBoundary

  useEffect(() => {
    const now = Date.now()
    const boundaries = reservations
      .filter((reservation) => reservation && ['pending', 'approved'].includes(reservation.status || 'approved'))
      .flatMap((reservation) => [timestamp(reservation, 'departure'), timestamp(reservation, 'return')])
      .filter((time) => time > now)
    if (!boundaries.length) return
    const delay = Math.min(Math.min(...boundaries) - now + 1, 2147483647)
    const timer = setTimeout(() => {
      setTick((previous) => previous + 1)
      callback.current?.()
    }, delay)
    return () => clearTimeout(timer)
  }, [reservations, tick])

  return Date.now()
}

export default useReservationClock
